import MoneyInterface from "../core/MoneyInterface";
import {StockInterface} from "./StockInterface";
import {AdditionalParamsInterface} from "./AdditionalParamsInterface";
import {FilterTypeInterface} from "../catalog/FilterTypeInterface";
import {ProductPropertyInterface} from "./ProductPropertyInterface";

export enum ProductBrand {
    PRIDE = 'pride',
    THORVIK = 'thorvik',
    JONNESWAY = 'jonnesway',
    OMBRA = 'ombra',
    CARBONTOOLS = 'carbontools',
    FILLINN = 'fillinn'
}

export interface ProductInterface {
    current_price: MoneyInterface
    base_price: MoneyInterface
    has_discount: boolean
    discount: number
    discount_percent: number
    base_stock: StockInterface
    smart_stock: string
    has_stock: boolean
    smart_stock_label: string

    client_price?: MoneyInterface
    client_base_price?: MoneyInterface
    client_base_stock?: StockInterface
    client_smart_stock?: string
    has_client_stock?: boolean
    client_smart_stock_label?: string

    popularity_index: number
    sizes_index: number
    is_new: boolean
    is_top: boolean
    properties: Record<string, string[]>
    properties_dictionary: Record<string, ProductPropertyInterface>
    list_image: string
    is_allow_to_sale: boolean
    human_url: string
    id: number
    code: string
    articul: string
    name: string
    brand_name: string
    normalized_brand_name: ProductBrand
    category_id: number
    weight: number
    volume: number
    width: number
    height: number
    length: number
    additional_params: AdditionalParamsInterface
    images: any[]
    arrival_date: string
    external_vendor_info: Record<string, any>[]
}